// @flow

import Config from 'constants/Config';

const Constants = {
  supportedLocales: [
    {
      locale: 'fr',
      name: 'Français',
    },
    {
      locale: 'en',
      name: 'English',
    },
    {
      locale: 'de',
      name: 'Deutsch',
    }
  ],

  localesForTranslation: [
    // too much locales render badly on the bo, we chose to comment some that are not likely to be
    // used
    // { "locale": "af-ZA", "name": "Afrikaans" },
    { locale: 'bg-BG', name: 'Bulgarian', },
    { locale: 'ca-AD', name: 'Catalan', },
    { locale: 'cs-CZ', name: 'Czech', },
    { locale: 'cy-GB', name: 'Welsh', },
    { locale: 'da-DK', name: 'Danish', },
    // { "locale": "de-AT", "name": "Deutsch - German (Austria)" },
    // { "locale": "de-CH", "name": "Deutsch - German (Switzerland)" },
    { locale: 'de-DE', name: 'Deutsch - German (Germany)', },
    { locale: 'el-GR', name: 'Greek', },
    { locale: 'en-AU', name: 'English (Australia)', },
    { locale: 'en-GB', name: 'English (UK)', },
    { locale: 'en-US', name: 'English (US)', },
    // { "locale": "es-CL", "name": "Spanish (Chile)" },
    { locale: 'es-ES', name: 'Spanish (Spain)', },
    // { "locale": "es-MX", "name": "Spanish (Mexico)" },
    { locale: 'et-EE', name: 'Estonian', },
    // { "locale": "fa-IR", "name": "Persian" },
    { locale: 'fi-FI', name: 'Finnish', },
    // { "locale": "fr-CA", "name": "French (Canada)" },
    { locale: 'fr-FR', name: 'French (France)', },
    // { "locale": "gl-ES", "name": "Galician (Spain)" },
    // { "locale": "he-IL", "name": "Hebrew" },
    // { "locale": "hi-IN", "name": "Hindi" },
    { locale: 'hr-HR', name: 'Croatian', },
    { locale: 'hu-HU', name: 'Hungarian', },
    // { "locale": "id-ID", "name": "Indonesian" },
    { locale: 'is-IS', name: 'Icelandic', },
    { locale: 'it-IT', name: 'Italian', },
    // { "locale": "ja-JP", "name": "Japanese" },
    // { "locale": "km-KH", "name": "Khmer" },
    // { "locale": "ko-KR", "name": "Korean" },
    { locale: 'lt-LT', name: 'Lithuanian', },
    // { "locale": "lv-LV", "name": "Latvian" },
    // { "locale": "mn-MN", "name": "Mongolian" },
    { locale: 'nb-NO', name: 'Norwegian (Bokmål)', },
    { locale: 'nl-NL', name: 'Dutch (Nederlands)', },
    { locale: 'nn-NO', name: 'Norwegian (Nynorsk)', },
    // { "locale": "pa-PK", "name": "Punjabi (Shahmukhi)" },
    { locale: 'pl-PL', name: 'Polish', },
    // { "locale": "pt-BR", "name": "Portuguese (Brazil)" },
    { locale: 'pt-PT', name: 'Portuguese (Portugal)', },
    { locale: 'ro-RO', name: 'Romanian', },
    // { "locale": "ru-RU", "name": "Russian" },
    { locale: 'sk-SK', name: 'Slovak', },
    { locale: 'sl-SI', name: 'Slovenian', },
    { locale: 'sr-RS', name: 'Serbian', },
    { locale: 'sv-SE', name: 'Swedish', },
    // { "locale": "th-TH", "name": "Thai" },
    // { "locale": "tr-TR", "name": "Turkish" },
    // { "locale": "uk-UA", "name": "Ukrainian" },
    // { "locale": "vi-VN", "name": "Vietnamese" },
    // { "locale": "zh-CN", "name": "Chinese (PRC)" },
    // { "locale": "zh-TW", "name": "Chinese (Taiwan)" },
  ],

  Order: {
    // Time to wait before sending the new manufacture delay value.
    DELAY_SEND_NEW_MANUFACTURE_DELAY: 3 * 1000, // in seconds

    // Time to wait before check for new order.
    DELAY_CHECK_NEW_ORDERS: Config.IS_DEV ? 20 * 1000 : 30 * 1000, // in seconds

    MAX_MANUFACTURE_DELAY: 2880, // in minutes 2880 for J&J Boulangerie
  },

  Booking: {
    DELAY_CHECK_UPDATED_BOOKINGS: 30 * 1000, // in seconds

    DELAY_CHECK_CALENDAR: Config.IS_DEV ? 40 * 1000 : 30 * 1000, // in seconds
  },

  Error: {
    NO_INTERNET: -1,

    UNKNOWN: 0,
  },

  CONTACT_EMAIL: 'support@paymytable.com',

  LIMIT_WAITING_BOOKINGS_LIST: Config.IS_DEV ? 20 : 40,

  Day: {
    MONDAY: 0,
    TUESDAY: 1,
    WEDNESDAY: 2,
    THURSDAY: 3,
    FRIDAY: 4,
    SATURDAY: 5,
    SUNDAY: 6,
  },

  Notification: {
    Type: {
      ORDER_NEW: 0,
    },
    AudioFile: {
      // filenames
      ORDER_NEW: 'new_order_notification',
    },
  },

  /**
   * Keys for the items stores on the local storage for the current user.
   * !!! Warning: You should remove all the keys that are specific to the user on logout.
   */
  SessionKey: {
    RESTAURANT_ID: 'restaurantId',
    RESTAURANT_GROUPS_ID: 'RESTAURANT_GROUPS_ID',
    ROLES_LIST: 'ROLES', // if change, change also on ProAccountStore and Security context
    ACCOUNT: 'ACCOUNT', // if change, change also on ProAccountStore and Security context
    AUTHORIZATION: 'auth',
    PRO_OAUTH: 'PRO_OAUTH',
    TIMELAPSE: 'timelapse',
    TIMELAPSE_SELECTION: 'TIMELAPSE_SELECTION',
    NEW_BOOKING_DATE: 'NEW_BOOKING_DATE',
    BOOKING_BOOK_DATE: 'BOOKING_BOOK_DATE',
    PRO_DOMAIN_ID: 'PRO_DOMAIN_ID',
    LOCALE: 'locale',

    // -- Those are the id to save the current opened tab.
    EDIT_RESTAURANT_TAB: 'EDIT_RESTAURANT_TAB',
    RECEIPT_PAGE_TAB: 'RECEIPT_PAGE_TAB',
    BOOKING_BOOK_TAB: 'BOOKING_BOOK_TAB',
    BOOKING_SETTINGS_TAB: 'BOOKING_SETTINGS_TAB',
    RESTAURANT_MENU_TAB: 'RESTAURANT_MENU_TAB',
  },
};

export default Constants;
